export const languages = [
    {
        "key": "de",
        "content": {
            "errors": {
                "arguments": {
                    "field_required": "Dieses Feld ist erforderlich",
                    "required_value_defaulted": "Standardwert für fehlenden erforderlichen Parameterwert angegeben"
                },
                "array_type_expected": "Typ '{{Array}}' erwartet, aber nicht erhalten",
                "definitions": {
                    "spec_required": "Die Definition muss Folgendes enthalten: '{{spec}}'",
                    "trigger_required": "Die Flussspezifikation muss Folgendes enthalten: '{{trigger}}'",
                    "trigger_variables.name_required": "Die Definition muss Folgendes enthalten: '{{name}}'"
                },
                "failed_to_find_symbol": "Symbol für '{{symbolName}}' nicht gefunden",
                "invalid_blueprint_reference": "Die Blueprint-Referenz ist ungültig",
                "parse_failed": "Die Flussdefinition muss mit einem der folgenden Elemente beginnen: '{{flow}}', '{{blueprint}}', '{{action}}'",
                "symbol_referenced_before_declaration": "Symbol mit Blockbereich '{{symbolName}}' wurde vor seiner Deklaration verwendet",
                "trigger_variables": {
                    "name_clash": "Es gibt bereits eine Variable mit diesem Namen",
                    "name_required": "Der Variablenname ist ein Pflichtfeld"
                },
                "unexpected_array_type": "Unerwarteter {{Array}}-Typ wurde empfangen",
                "unknown": "unbekannt"
            }
        }
    },
    {
        "key": "en",
        "content": {
            "errors": {
                "arguments": {
                    "field_required": "This field is required",
                    "required_value_defaulted": "Missing required parameter value was defaulted"
                },
                "array_type_expected": "{{Array}} type expected, but not received",
                "definitions": {
                    "spec_required": "Definition must contain: '{{spec}}'",
                    "trigger_required": "Flow spec must contain: '{{trigger}}'",
                    "trigger_variables.name_required": "Definition must contain: '{{name}}'"
                },
                "failed_to_find_symbol": "Failed to find symbol for: '{{symbolName}}'",
                "invalid_blueprint_reference": "Blueprint reference is invalid",
                "parse_failed": "Flow definition must begin with one of: '{{flow}}', '{{blueprint}}', '{{action}}'",
                "symbol_referenced_before_declaration": "Block-scoped symbol '{{symbolName}}' used before its declaration",
                "trigger_variables": {
                    "name_clash": "There's already a variable with this name",
                    "name_required": "Variable name is a required field"
                },
                "unexpected_array_type": "Received unexpected {{Array}} type",
                "unknown": "unknown"
            }
        }
    },
    {
        "key": "es",
        "content": {
            "errors": {
                "arguments": {
                    "field_required": "Este campo es obligatorio",
                    "required_value_defaulted": "Para el parámetro requerido que falta se ha utilizado el valor predeterminado"
                },
                "array_type_expected": "Tipo de {{Array}} esperado, pero no recibido",
                "definitions": {
                    "spec_required": "La definición debe contener: '{{spec}}'",
                    "trigger_required": "La especificación de flujo debe contener: '{{trigger}}'",
                    "trigger_variables.name_required": "La definición debe contener: '{{name}}'"
                },
                "failed_to_find_symbol": "No se pudo encontrar el símbolo para: '{{symbolName}}'",
                "invalid_blueprint_reference": "La referencia al plano no es válida",
                "parse_failed": "La definición de flujo debe comenzar por uno de los siguientes: '{{flow}}', '{{blueprint}}', '{{action}}'",
                "symbol_referenced_before_declaration": "Símbolo de ámbito de bloque '{{symbolName}}' utilizado antes de su declaración",
                "trigger_variables": {
                    "name_clash": "Ya existe una variable con este nombre",
                    "name_required": "El nombre de la variable es un campo obligatorio"
                },
                "unexpected_array_type": "Recibido tipo de {{Array}} no esperado",
                "unknown": "desconocido"
            }
        }
    },
    {
        "key": "fr",
        "content": {
            "errors": {
                "arguments": {
                    "field_required": "Ce champ est obligatoire",
                    "required_value_defaulted": "La valeur de paramètre obligatoire manquante a été définie sur la valeur par défaut"
                },
                "array_type_expected": "Type {{Array}} attendu, mais non reçu",
                "definitions": {
                    "spec_required": "La définition doit contenir : '{{spec}}'",
                    "trigger_required": "La spécification de flux doit contenir : '{{trigger}}'",
                    "trigger_variables.name_required": "La définition doit contenir : '{{name}}'"
                },
                "failed_to_find_symbol": "Symbole introuvable pour : '{{symbolName}}'",
                "invalid_blueprint_reference": "La référence du blueprint n'est pas valide",
                "parse_failed": "La définition de flux doit commencer par l'un des éléments suivants : '{{flow}}', '{{blueprint}}', '{{action}}'",
                "symbol_referenced_before_declaration": "Symbole de portée de bloc '{{symbolName}}' utilisé avant sa déclaration",
                "trigger_variables": {
                    "name_clash": "Il existe déjà une variable portant ce nom",
                    "name_required": "Le nom de la variable est un champ obligatoire"
                },
                "unexpected_array_type": "Type {{Array}} inattendu reçu",
                "unknown": "inconnu"
            }
        }
    },
    {
        "key": "it",
        "content": {
            "errors": {
                "arguments": {
                    "field_required": "Questo campo è obbligatorio",
                    "required_value_defaulted": "Il valore del parametro obbligatorio mancante è stato impostato in base al valore predefinito"
                },
                "array_type_expected": "Tipo {{Array}} previsto, ma non ricevuto",
                "definitions": {
                    "spec_required": "La definizione deve contenere: \"{{spec}}\"",
                    "trigger_required": "Le specifiche di flusso devono contenere: \"{{trigger}}\"",
                    "trigger_variables.name_required": "La definizione deve contenere: \"{{name}}\""
                },
                "failed_to_find_symbol": "Impossibile trovare il simbolo per: \"{{symbolName}}\"",
                "invalid_blueprint_reference": "Il riferimento al blueprint non è valido",
                "parse_failed": "La definizione del flusso deve iniziare con uno dei seguenti elementi: \"{{flow}}\", \"{{blueprint}}\", \"{{action}}\"",
                "symbol_referenced_before_declaration": "Simbolo con ambito di blocco \"{{symbolName}}\" utilizzato prima della sua dichiarazione",
                "trigger_variables": {
                    "name_clash": "Esiste già una variabile con questo nome",
                    "name_required": "Il nome della variabile è un campo obbligatorio"
                },
                "unexpected_array_type": "Ricevuto tipo {{Array}} imprevisto",
                "unknown": "sconosciuto"
            }
        }
    },
    {
        "key": "ja",
        "content": {
            "errors": {
                "arguments": {
                    "field_required": "このフィールドは必須です",
                    "required_value_defaulted": "必須パラメーター値がないため、デフォルトに設定されました"
                },
                "array_type_expected": "種類 {{Array}} が想定されましたが、受信しませんでした",
                "definitions": {
                    "spec_required": "定義には次のものが含まれている必要があります: '{{spec}}'",
                    "trigger_required": "フローの指定には次のものが含まれている必要があります: '{{trigger}}'",
                    "trigger_variables.name_required": "定義には次のものが含まれている必要があります: '{{name}}'"
                },
                "failed_to_find_symbol": "次の記号が見つかりませんでした: '{{symbolName}}'",
                "invalid_blueprint_reference": "ブループリントの参照が無効です",
                "parse_failed": "フローの定義は次のうちいずれかで始める必要があります: '{{flow}}'、'{{blueprint}}'、'{{action}}'",
                "symbol_referenced_before_declaration": "ブロックスコープの記号 '{{symbolName}}' が宣言前に使用されています",
                "trigger_variables": {
                    "name_clash": "この名前の変数は既に存在します",
                    "name_required": "変数名は必須フィールドです"
                },
                "unexpected_array_type": "予期しない種類 {{Array}} を受信しました",
                "unknown": "不明"
            }
        }
    },
    {
        "key": "ko",
        "content": {
            "errors": {
                "arguments": {
                    "field_required": "이 필드는 필수입니다",
                    "required_value_defaulted": "누락된 필수 매개변수 값이 기본값으로 설정되었습니다"
                },
                "array_type_expected": "{{Array}} 유형이 예상되지만 수신되지 않았습니다",
                "definitions": {
                    "spec_required": "정의에는 '{{spec}}'이(가) 포함되어야 합니다",
                    "trigger_required": "플로우 사양에는 '{{trigger}}'이(가) 포함되어야 합니다",
                    "trigger_variables.name_required": "정의에는 '{{name}}'이(가) 포함되어야 합니다"
                },
                "failed_to_find_symbol": "'{{symbolName}}'의 기호를 찾지 못했습니다",
                "invalid_blueprint_reference": "블루프린트 참조가 잘못되었습니다",
                "parse_failed": "플로우 정의는 '{{flow}}', '{{blueprint}}', '{{action}}' 중 하나로 시작해야 합니다",
                "symbol_referenced_before_declaration": "선언 전에 블록 범위 기호 '{{symbolName}}'이(가) 사용되었습니다",
                "trigger_variables": {
                    "name_clash": "이 이름을 가진 변수가 이미 있습니다",
                    "name_required": "변수 이름은 필수 필드입니다"
                },
                "unexpected_array_type": "예상치 못한 {{Array}} 유형을 수신했습니다",
                "unknown": "알 수 없음"
            }
        }
    },
    {
        "key": "nl",
        "content": {
            "errors": {
                "arguments": {
                    "field_required": "Dit veld is verplicht",
                    "required_value_defaulted": "Ontbrekende vereiste parameterwaarde is standaard ingesteld"
                },
                "array_type_expected": "{{Array}} type verwacht, maar niet ontvangen",
                "definitions": {
                    "spec_required": "De definitie moet het volgende bevatten: '{{spec}}'",
                    "trigger_required": "De stroomspecificatie moet het volgende bevatten: '{{trigger}}'",
                    "trigger_variables.name_required": "De definitie moet het volgende bevatten: '{{name}}'"
                },
                "failed_to_find_symbol": "Kan symbool niet vinden voor: '{{symbolName}}'",
                "invalid_blueprint_reference": "Verwijzing naar blauwdruk is ongeldig",
                "parse_failed": "De stroomdefinitie moet beginnen met een van deze: '{{flow}}', '{{blueprint}}', '{{action}}'",
                "symbol_referenced_before_declaration": "Block-scoped symbool '{{symbolName}}\" gebruikt vóór de declaratie ervan",
                "trigger_variables": {
                    "name_clash": "Er is al een variabele met deze naam",
                    "name_required": "Naam van variabele is een verplicht veld"
                },
                "unexpected_array_type": "Onverwacht type {{Array}} ontvangen",
                "unknown": "onbekend"
            }
        }
    },
    {
        "key": "pt-BR",
        "content": {
            "errors": {
                "arguments": {
                    "field_required": "Este campo é obrigatório",
                    "required_value_defaulted": "O valor do parâmetro obrigatório ausente foi definido com o valor padrão"
                },
                "array_type_expected": "Tipo {{Array}} esperado, mas não recebido",
                "definitions": {
                    "spec_required": "A definição deve conter: '{{spec}}'",
                    "trigger_required": "A especificação de fluxo deve conter: '{{trigger}}'",
                    "trigger_variables.name_required": "A definição deve conter: '{{name}}'"
                },
                "failed_to_find_symbol": "Falha ao encontrar o símbolo para: '{{symbolName}}'",
                "invalid_blueprint_reference": "A referência do blueprint é inválida",
                "parse_failed": "A definição do fluxo deve começar com um dos seguintes: '{{flow}}', '{{blueprint}}', '{{action}}'",
                "symbol_referenced_before_declaration": "Símbolo de escopo de bloco '{{symbolName}}' usado antes de sua declaração",
                "trigger_variables": {
                    "name_clash": "Já existe uma variável com este nome",
                    "name_required": "O nome da variável é um campo obrigatório"
                },
                "unexpected_array_type": "Recebeu um tipo {{Array}} inesperado",
                "unknown": "desconhecido"
            }
        }
    },
    {
        "key": "ru",
        "content": {
            "errors": {
                "arguments": {
                    "field_required": "Это обязательное поле",
                    "required_value_defaulted": "Отсутствующее требуемое значение параметры было установлено на значение по умолчанию"
                },
                "array_type_expected": "Ожидался тип {{Array}}, но этот тип не был получен",
                "definitions": {
                    "spec_required": "Определение должно содержать: '{{spec}}'",
                    "trigger_required": "Спецификация потока должна содержать: '{{trigger}}'",
                    "trigger_variables.name_required": "Определение должно содержать: '{{name}}'"
                },
                "failed_to_find_symbol": "Не удалось найти символ для: '{{symbolName}}'",
                "invalid_blueprint_reference": "Ссылка на чертеж недействительна",
                "parse_failed": "Определение потока должно начинаться с одного из следующих значений: '{{flow}}', '{{blueprint}}', '{{action}}'",
                "symbol_referenced_before_declaration": "Символ блочной области '{{symbolName}}', используемый перед его объявлением",
                "trigger_variables": {
                    "name_clash": "Переменная с таким именем уже есть",
                    "name_required": "Имя переменной является обязательным полем"
                },
                "unexpected_array_type": "Получен неожиданный тип {{Array}}",
                "unknown": "неизвестно"
            }
        }
    },
    {
        "key": "zh-CN",
        "content": {
            "errors": {
                "arguments": {
                    "field_required": "此字段为必填字段",
                    "required_value_defaulted": "默认为缺少必需的参数值"
                },
                "array_type_expected": "预期类型为 {{Array}}，但未收到",
                "definitions": {
                    "spec_required": "定义必须包含: {{spec}}",
                    "trigger_required": "流规范必须包含: {{trigger}}",
                    "trigger_variables.name_required": "定义必须包含: {{name}}"
                },
                "failed_to_find_symbol": "找不到“{{symbolName}}”的符号",
                "invalid_blueprint_reference": "蓝图参考无效",
                "parse_failed": "流定义必须以下面的其中一项开头: {{flow}}、{{blueprint}}、{{action}}",
                "symbol_referenced_before_declaration": "在声明之前使用了块作用域符号“{{symbolName}}”",
                "trigger_variables": {
                    "name_clash": "已存在一个使用此名称的变量",
                    "name_required": "“变量名称”为必填字段"
                },
                "unexpected_array_type": "收到意外的 {{Array}} 类型",
                "unknown": "未知"
            }
        }
    }
];
//# sourceMappingURL=index.js.map